import { AutocheckoutFormComponent } from './autocheckout-form/autocheckout-form.component';
import { CustomizationComponent } from './../food/menu/customization/customization.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { StoreCardListComponent } from './store-card-list/store-card-list.component';
import { SplitWithPipe } from 'src/app/pipes/split-with.pipe';
import { SlugifyPipe } from 'src/app/pipes/slugify.pipe';
import { BottomModalComponent } from 'src/app/modals/bottom-modal/bottom-modal.component';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NoDataComponent } from './screens/no-data/no-data.component';
import { NoNetworkComponent } from './screens/no-network/no-network.component';
import { GenericErrorComponent } from './screens/generic-error/generic-error.component';
import { CouponCardComponent } from './coupon-card/coupon-card.component';
import { ProductCardListComponent } from './product-card-list/product-card-list.component';
import { CheckoutFormComponent } from './checkout-form/checkout-form.component';
@NgModule({
  declarations: [
    StoreCardListComponent,
    SplitWithPipe,
    CustomizationComponent,
    BottomModalComponent,
    SlugifyPipe,
    SafeHtmlPipe,
    NoDataComponent,
    NoNetworkComponent,
    GenericErrorComponent,
    CouponCardComponent,
    ProductCardListComponent,
    CheckoutFormComponent,
    AutocheckoutFormComponent
  ],
  imports: [
    TranslateModule,
    IonicModule,
    FormsModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule
  ],
  providers: [
    SlugifyPipe,
    SafeHtmlPipe
  ],
  exports: [
    StoreCardListComponent,
    CustomizationComponent,
    BottomModalComponent,
    SlugifyPipe,
    SafeHtmlPipe,
    TranslateModule,
    FormsModule,
    CommonModule,
    NoDataComponent,
    NoNetworkComponent,
    GenericErrorComponent,
    SplitWithPipe,
    CouponCardComponent,
    ProductCardListComponent,
    CheckoutFormComponent,
    AutocheckoutFormComponent
  ]

})
export class ShoppingSharedModule { }
